<!-- an hidden div is created to set the position of appearance of the menu--> 
<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Nombre modulo y tablero-->
    <div class="w3-caja-menu padreizquierda w3-quarter ">
      <div class="w3-row hijoizquierda ">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate}}</b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate}} </span>
      </div>
    </div>
    <!--Filtro años (periodo)-->
    <div class="w3-caja-menu padreizquierda w3-rest ">
      <div class="w3-quarter padreizquierda " style="margin-right: 1vh;">
    <app-filters 
      [name]="'filtros.per' | translate"
      [array]="Periodos" 
      [typeFilter]="Filters.PERIOD"
      [click]="true"
      (eventClick)="cambioPeriodo($event)">
    </app-filters>
    </div>
    </div>
  </div>
  <!--Contenido Tablero-->
  <div class="w3-row workSpaceTab ">
    <!--zona superior del tablero-->
    <div class="zonaSuperior">
      <!--Tabla-->
      <div class="zonaTabla w3-white">
        <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
          <div class="w3-noventa"> <!--titulo tabla-->
            @if(idPlantilla === 7){
              <span class="w3-margin-left-contenido">{{'credito.concentracion.tituloTabla' + encabezadoMetrica | translate}} |</span>
            }@else {
              <span class="w3-margin-left-contenido">{{'liquidez.concentracion.tituloTabla' + encabezadoMetrica | translate}} |</span>
            }
            <span class=""> {{encPerspectiva}} </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
          </div>
          <div class="w3-rest w3-right "> <!--menu tabla-->
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuPerspectiva">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
                <span>{{'menu.Perspectivas' | translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuMetrica">
                <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
                <span>{{'menu.Metrica' | translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #menuPerspectiva="matMenu">
              @if(idPlantilla === 7){
                @for (i of perspectivas; track pos; let pos = $index) {
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':i === encPerspectiva}" [disabled]="i === encPerspectiva" (click)="cambioPerspectiva(pos)">
                    <span>{{i}}</span>
                  </button>
                }
              }@else {
                @for (i of perspectivas; track pos; let pos = $index) {
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':i === encPerspectiva}" [disabled]="i === encPerspectiva" (click)="cambioPerspectiva(pos)">
                    <span>{{i.name}}</span>
                  </button>
                }
              }              
            </mat-menu>
            <mat-menu #menuMetrica="matMenu">
              @if (idPlantilla === 7) {
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encabezadoMetrica === 1}" [disabled]="encabezadoMetrica === 1" (click)="cambioMetrica('Saldos')">
                  <span>{{'credito.concentracion.titulo1Tabla1'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encabezadoMetrica === 2}" [disabled]="encabezadoMetrica === 2" (click)="cambioMetrica('Cuentas')">
                  <span>{{'credito.concentracion.titulo1Tabla2'|translate}}</span>
                </button>  
              }@else{
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encabezadoMetrica === 1}" [disabled]="encabezadoMetrica === 1" (click)="cambioMetrica('Todas')">
                  <span>{{'liquidez.concentracion.metrica1'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encabezadoMetrica === 2}" [disabled]="encabezadoMetrica === 2" (click)="cambioMetrica('Nacional')">
                  <span>{{'liquidez.concentracion.metrica2'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encabezadoMetrica === 3}" [disabled]="encabezadoMetrica === 3" (click)="cambioMetrica('Extranjera')">
                  <span>{{'liquidez.concentracion.metrica3'|translate}}</span>
                </button>
              }
            </mat-menu>
          </div>
        </div>
        <!--Tabla contenido-->
        <div class="tabla w3-scroll">
          @if (datos.length !== 0) {
            <table class="w3-table borderInf">
              <thead>
                <!--titulos tabla-->
                @if(idPlantilla === 7){
                  <tr class="w3-center">
                    <th class="stikyColumBlanco"></th>
                    <th class="stikyColumBlanco"></th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" colspan="2">{{'liquidez.concentracion.metrica'  + encabezadoMetrica| translate }}</th>
                    <!--<th class="w3-table-titleLow stikyColumCon" colspan="2">{{'credito.concentracion.titulo2Tabla' | translate }}</th>-->
                    <th class="w3-table-titleLow stikyColumCon" colspan="3">{{'credito.concentracion.titulo3Tabla' | translate }}</th>
                  </tr>
                  <tr class="w3-table-title w3-center">
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.concentracion.encabezado1' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.concentracion.encabezado2' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">
                      {{'credito.concentracion.encabezado3' + encabezadoMetrica | translate}}
                      <mat-icon class="iconoMen" matTooltip="{{'credito.concentracion.info' | translate}}">info</mat-icon>
                    </th>
                    <th class="stikyColumCon2 w3-border-right-balance">%</th>
                    <th class="stikyColumCon2 w3-border-right-balance">% {{'credito.concentracion.encabezado4' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance ">% {{'credito.concentracion.encabezado5' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.concentracion.encabezado6' | translate}}</th>
                  </tr>
                }@else {
                  <tr class="w3-table-title w3-center">
                    <th class="stikyColumCon w3-border-right-balance">{{'credito.concentracion.encabezado1' | translate}}</th>
                    <th class="stikyColumCon w3-border-right-balance">
                      {{'credito.concentracion.encabezado31' | translate}}
                      <mat-icon class="iconoMen" matTooltip="{{'credito.concentracion.info' | translate}}">info</mat-icon>
                    </th>
                    <th class="stikyColumCon w3-border-right-balance">%</th>
                  </tr>
                }                
              </thead>
              @for (i of datos; track pos; let pos = $index) {
                <tbody>
                  <!--Filas de la tabla contenido general-->
                <tr class="w3-table-trtd borderInfLow" [ngClass]="{'filaTotales': i.descripcion === 'Total'}">
                  <td  class="borderAllLow">
                    <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">{{i.descripcion}}</span>
                  </td>
                  @if(idPlantilla === 7){
                    <td class = "alinRight borderAllLow marginDer">
                      @if (i.promedio+'' !== 'NaN') {
                        <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">{{formatoNum(i.promedio, false)}}</span>
                      }@else {
                        <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">0</span>
                      }
                    </td>  
                  }
                  <td class = "alinRight borderAllLow marginDer">
                    @if (i.monto !== null) {
                      <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">{{formatoNum(i.monto, false)}}</span>
                    }@else {
                      <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">0</span>
                    }
                  </td>
                  <td class = "alinCenter borderAllLow">
                    @if (i.porcentaje+'' !== 'NaN') {
                      <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">{{formatoNum((i.porcentaje*100).toFixed(1), true) + ' %'}}</span>
                    }@else {
                      <span [ngClass]="{'txtTotales': i.descripcion === 'Total'}">0</span>
                    }
                  </td>
                  <!--Columna del minimo-->
                  @if(idPlantilla == 7){
                    <td  class="anchoValores alinRight borderAllLow" style="width: 250px;">
                      <div matTooltip="Editar" class="inputSpan" [ngClass]="{'txtTotales': i.descripcion === 'Total'}" (dblclick)="actualizarLimits(i , 'min')">
                        @if (i.min+'' !== 'NaN' && i.min+'' !== 'null') {
                          <span> {{formatoNum(obtLimit(i,'min'), true)}} % </span>
                        }@else {
                          <span> 0 % </span>
                        }
                        <mat-icon class="iconoMen"  >edit</mat-icon>
                      </div>
                    </td>
                    <!--Columna del maximo-->
                    <td  class="anchoValores alinRight borderAllLow" style="width: 250px;">
                      <div matTooltip="Editar" class="inputSpan" [ngClass]="{'txtTotales': i.descripcion === 'Total'}" (dblclick)="actualizarLimits(i , 'max')">
                        @if (i.max+'' !== 'NaN' && i.max+'' !== 'null') {
                          <span> {{formatoNum(obtLimit(i,'max'), true)}} % </span>
                        }@else {
                          <span> 0 % </span>
                        }
                        <mat-icon class="iconoMen"  >edit</mat-icon>
                      </div>
                    </td>
                    <!--En rango-->
                    <td class="alinCenter borderAllLow">
                      @if (enRango(i) == 'check_circle') {
                        <mat-icon class="iconoMen" matTooltip="Cumple los límites" [ngStyle]="{'color':'#8bc34a'}">{{enRango(i)}}</mat-icon>
                      }@else if (enRango(i) == 'cancel') {
                        <mat-icon class="iconoMen" matTooltip="No cumple los límites" [ngStyle]="{'color':'red'}">{{enRango(i)}}</mat-icon>
                      }@else if (enRango(i) == 'help') {
                        <mat-icon class="iconoMen" matTooltip="No hay límites o son incongruentes" [ngStyle]="{'color':'#00B0F0'}">{{enRango(i)}}</mat-icon>
                      }
                    </td>
                  }
                </tr>
                </tbody>
              }
              <!--Fila totales -->
              <tbody>
                <tr class="w3-table-trtd filaTotales">
                  <td  class="borderAllLow">
                    <span class="alinCenter txtTotales">{{totales.descripcion}}</span>
                  </td>
                  @if (idPlantilla === 7) {
                    <td class = "alinRight borderAllLow">
                      @if (totales.promedio+'' !== 'NaN') {
                        <span class="alinCenter txtTotales">{{formatoNum(totales.promedio, false)}}</span>
                      }@else {
                        <span class="alinCenter txtTotales">0</span>
                      }
                    </td>
                  }
                  <td class = "alinRight borderAllLow">
                    <span class="alinCenter txtTotales">{{formatoNum(totales.monto, false)}}</span>
                  </td>
                  <td class = "alinCenter borderAllLow">
                    @if (totales.porcentaje+'' !== 'NaN') {
                      <span class="alinCenter txtTotales">{{formatoNum(totales.porcentaje*100, false) + ' %'}}</span>
                    }@else {
                      <span class="alinCenter txtTotales">0</span>
                    }
                  </td>
                  @if (idPlantilla === 7) {
                    <td class = "alinRight">
                      <span class="alinCenter txtTotales"></span>
                    </td>
                    <td class = "alinRight">
                      <span class="alinCenter txtTotales"></span>
                    </td>
                    <td>
                      <span class="alinCenter txtTotales "></span>
                    </td>
                    <td>
                      <span class="alinCenter txtTotales "></span>
                    </td>
                    <td>
                      <span class="alinCenter txtTotales "></span>
                    </td>
                  }
                </tr>
              </tbody>
            </table>
          }@else {
            <div class="preview-background">
              <div class="page">
                <ngx-skeleton-loader count="7" [theme]="{ 
                  'border-radius': '10px',
                  height: '2vh',
                  width: '55vw',
                }" />
              </div>
            </div>
          }
        </div>
      </div>
      <!--Tarjeta-->
      <div class="zonaTarjeta">
        <div class="card-wrapper">
          <h2 class="card-title">Evaluación de la concentración</h2>
          <p class="card-subtitle">Índice Herfindahl & Hirschman</p>

          <div class="card-body">
            <!-- Lado izquierdo: círculo -->
            <div class="circle-side">
              <span class="circle-label">{{txtParametro}}</span>
              <img class="imagen" src="{{'assets/iconos/'+txtImg+'.png'}}">
            </div>

            <!-- Lado derecho: métrica -->
            <div class="info-side">
              <div class="metric-card">
                <div class="metric-icon">
                  <mat-icon>
                    data_thresholding
                  </mat-icon>
                </div>
                <span class="metric-name">IHH</span>
                <div class="metric-right">
                  <div class="metric-value">
                    @if (ihh) {
                      {{formatoNum(ihh, false)}}
                    }@else{
                      0
                    }
                  </div>
                  <div class="metric-date">{{escrituraPeriodo(subTitles)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="zonaTarjeta">
        <div class="w3-center">
          <div>
            <div class="w3-titulo-contenidomenuSC ">
              <div style="font-weight: normal; font-weight: bold; height: 3.5vh !important;">Evaluación de la concentración</div>
              <div style="font-weight: normal; font-weight: bold; padding: 0;">Índice Herfindahl & Hirschman</div>
            </div>
            @if(txtParametro !== ''){
              <div style="padding-top: 10px; height: 25vh;">
                <div style="width: 50%; float: left;" class="">
                  <span class="indParametro w3-balance-bluep">{{txtParametro}}</span>
                  <br><br>
                  <img class = "imagen" src="{{'assets/iconos/'+txtImg+'.png'}}">
                </div>
                <div style="width: 35%; height: 20vh; float: left; padding-right: 40px;">
                  <table class="w3-table " style="margin-left: auto; margin-right: auto; margin-top: 5vh;">
                    <tbody>
                      <tr class="">
                        <td class="cAzul ">IHH</td>
                        <td>
                          @if (ihh+'' !== 'NaN') {
                            <span class = 'w3-titulo-titulotarjetas '>{{formatoNum(ihh, false)}}</span>
                          }@else {
                            <span class = 'w3-titulo-titulotarjetas '>0</span> 
                          }

                        </td>
                      </tr>
                      <tr class="">
                        <td class="cAzul">MIN</td>
                        <td>
                          <span class = 'w3-titulo-titulotarjetas'>{{formatoNum(min, false)}}</span>
                        </td>
                      </tr>
                      <tr class="">
                        <td class="cAzul">MÁX</td>
                        <td>
                          <span class = 'w3-titulo-titulotarjetas'>{{formatoNum(max, false)}}</span>
                        </td>
                      </tr>
                    </tbody>
                    
                  </table>
                </div>
              </div>
            }@else {
              <div class="preview-background">
              <div class="page">
                <ngx-skeleton-loader count="1" [theme]="{ 
                  'border-radius': '10px',
                  height: '28vh',
                  width: '35vw',
                }" />
              </div>
            </div>
            }            
          </div>
        </div>
      </div> -->
    </div>

    <!--zona inferior del tablero-->
    <div class="zonaInferior ">
      <!--Grafica-->
      <div class="zonaGrafica w3-white " id="conteGrafica">
        <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
          <div class="w3-titulo-cuadrante"> <!--titulo tabla-->
            <span class="w3-margin-left-contenido">{{
              'credito.concentracion.tituloTabla11'| translate}} |
            </span>
            <span class=""> {{encPerspectiva}} </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
          </div>
          <!--menu grafica-->
          <div class="w3-rest w3-right "> 
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas1= !etiquetas1" [matTooltip]="!etiquetas1 ? ('graf.activar'|translate) : 'graf.desactivar'|translate">
            {{!etiquetas1 ? 'label' : 'label_off'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf('concen')">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGrafica">
              more_vert
            </mat-icon>
            <mat-menu #menuGrafica="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica1()">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button></mat-menu>
            <mat-menu #tipoGrafica="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipo1 === 'bar' && tipo2 === 'line'}" [disabled]="tipo1 === 'bar' && tipo2 === 'line'"  (click)="cambiarTipoGrafica1('bar','line')">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'credito.concentracion.tipografica'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipo1 === 'bar' && tipo2 === 'bar'}" [disabled]="tipo1 === 'bar' && tipo2 === 'bar'" (click)="cambiarTipoGrafica1('bar','bar')">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipo1 === 'line' && tipo2 === 'line'}" [disabled]="tipo1 === 'line' && tipo2 === 'line'" (click)="cambiarTipoGrafica1('line','line')">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipo1 === 'area' && tipo2 === 'area'}" [disabled]="tipo1 === 'area' && tipo2 === 'area'" (click)="cambiarTipoGrafica1('area','area')">
                <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
              </button></mat-menu>
          </div>
        </div>
        <br>
        <div class="grafica">
          @if (dataGrafica1.length > 0 && labelsGrafica1.length > 0) {
            <app-graficador #graficador1
              [data]="dataGrafica1"
              [labels]="labelsGrafica1"
              [type]="tipoGraficaCombinada"
              [colors]="coloresGrafica"
              [axisY]="ejesYGrafica1"
              [axisX]="''"
              [zona]="1"
              [etiquetas]="etiquetas1"
              [changeLabel]="changeLabel1"
              [formatEtiquetas]="false"
              [legend]="{enabled: true, position: 'bottom'}"
              [altoEtiquetasX]="80">
            </app-graficador>
          }@else {
            <div class="preview-background">
              <div class="page">
                <ngx-skeleton-loader count="1" [theme]="{ 
                  'border-radius': '10px',
                  height: '36vh',
                  width: '45vw',
                }" />
              </div>
            </div>
          }
        </div>
      </div>

      <div class="zonaGrafica2 w3-white" id="conteGrafica2">
        <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
          <div class="w3-titulo-cuadrante"> <!--titulo tabla-->
            <span class="w3-margin-left-contenido">{{
              'credito.concentracion.tituloTabla11'| translate}} |
            </span>
            <span class=""> {{encPerspectiva}} </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{subTitlesH}}</span>
          </div>
          <!--menu grafica-->
          <div class="w3-rest w3-right "> 
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas2 = !etiquetas2" [matTooltip]="!etiquetas2 ? ('graf.activar'|translate) : 'graf.desactivar'|translate">
            {{!etiquetas2 ? 'label' : 'label_off'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf('histo')">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraficaH">
              more_vert
            </mat-icon>
            <mat-menu #menuGraficaH="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGraficaH">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica2()">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button></mat-menu>
            <mat-menu #tipoGraficaH="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':eje}" [disabled]="eje" (click)="cambiarTipoGrafica2(true)">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'credito.mayores.tipo1'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':!eje}" [disabled]="!eje" (click)="cambiarTipoGrafica2(false)">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'credito.mayores.tipo2'|translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <br>
        <div class="grafica">
          @if (dataGrafica2.length > 0 && labelsGrafica2.length > 0) {
            <app-graficador #graficador2
              [data]="dataGrafica2"
              [labels]="labelsGrafica2"
              [type]="tipoGrafica2"
              [colors]="coloresGrafica"
              [axisY]="['']"
              [axisX]="''"
              [zona]="2"
              [etiquetas]="etiquetas2"
              [changeLabel]="changeLabel2"
              [formatEtiquetas]="true"
              [legend]="{enabled: true, position: 'bottom'}">
            </app-graficador>
          }@else {
            <div class="preview-background">
              <div class="page">
                <ngx-skeleton-loader count="1" [theme]="{ 
                  'border-radius': '10px',
                  height: '36vh',
                  width: '45vw',
                }" />
              </div>
            </div>
          }
        </div>
      </div>
        
    </div>
  </div>
</div>

<!--Modal ampliar grafica-->
<div id="ampliar" class="modal" (click)="clickFuera($event)">
  <div class="modalContent " style="width: 80%;">
    <div class="w3-row w3-white">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-noventa w3-white">
        <div class="w3-row  w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle" >
            <span class="w3-margin-left-contenido">{{
              'credito.concentracion.tituloTabla' + encabezadoMetrica | translate}}
            </span>
            <span class="">| {{encPerspectiva}} </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <!-- ✅ CAMBIO: Mostrar subtítulo según la gráfica -->
            <span class="w3-margin-left-filter w3-subtitulo">
              {{ tituloModal === 'concen' ? escrituraPeriodo(subTitles) : subTitlesH }}
            </span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <!-- Iconos de etiqueta según la gráfica mostrada -->
          @if (tituloModal === 'concen') {
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas1 = !etiquetas1" [matTooltip]="!etiquetas1 ? ('graf.activar'|translate) : 'graf.desactivar'|translate">
              {{!etiquetas1 ? 'label' : 'label_off'}}
            </mat-icon>
            <!-- Exportar gráfica 1 -->
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="exportarGraficaModal()" 
            matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          @if (tituloModal === 'histo') {
            <mat-icon class="w3-margin-right-contenido w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas2 = !etiquetas2" [matTooltip]="!etiquetas2 ? ('graf.activar'|translate) : 'graf.desactivar'|translate">
              {{!etiquetas2 ? 'label' : 'label_off'}}
            </mat-icon>
            <!-- Exportar gráfica 2 -->
            <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="exportarGraficaModal()" 
            matTooltip="{{'menu.Exportar'|translate}}">
              image
            </mat-icon>
          }
          <!-- Cerrar modal -->
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" (click)="closeModal()">clear</mat-icon>
        </div>
      </div>
    </div>
    
    <!--area grafica-->
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
      <ng-container>
        <div class="w3-row contentGraf" id="graficaAmpliada">
          
          <!-- ✅ AGREGAR: Gráfica 1 Ampliada (Combinada) -->
          @if (tituloModal === 'concen' && dataGrafica1.length > 0 && labelsGrafica1.length > 0) {
            <app-graficador 
              [data]="dataGrafica1"
              [labels]="labelsGrafica1"
              [type]="tipoGraficaCombinada"
              [colors]="coloresGrafica"
              [axisY]="ejesYGrafica1"
              [axisX]="''"
              [zona]="3"
              [etiquetas]="etiquetas1"
              [changeLabel]="changeLabel1"
              [formatEtiquetas]="false"
              [legend]="{enabled: true, position: 'bottom'}">
            </app-graficador>
          }
          
          <!-- ✅ AGREGAR: Gráfica 2 Ampliada (Histórico) -->
          @if (tituloModal === 'histo' && dataGrafica2.length > 0 && labelsGrafica2.length > 0) {
            <app-graficador
              [data]="dataGrafica2"
              [labels]="labelsGrafica2"
              [type]="tipoGrafica2"
              [colors]="coloresGrafica"
              [axisY]="['%']"
              [axisX]="''"
              [zona]="4"
              [etiquetas]="etiquetas2"
              [changeLabel]="changeLabel2"
              [formatEtiquetas]="true"
              [legend]="{enabled: true, position: 'bottom'}">
            </app-graficador>
          }
        </div>
      </ng-container>
    </div>
  </div>
</div>




